export const URL_PPAL = 'http://localhost:3001';
export const URL_HOME = URL_PPAL + '/videogames';
export const URL_DETAIL = URL_PPAL + '/videogames';
export const URL_ADD_VIDEOGAME = URL_PPAL + '/videogame';
export const URL_SEARCH = URL_PPAL + '/videogames';


